namespace GeniuzPOS.Product {
    export namespace CsSkuService {
        export const baseUrl = 'Product/CsSku';

        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumberEAN(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CsSkuRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CsSkuRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            GetNextNumber = "Product/CsSku/GetNextNumber",
            GetNextNumberEAN = "Product/CsSku/GetNextNumberEAN",
            Retrieve = "Product/CsSku/Retrieve",
            List = "Product/CsSku/List"
        }

        [
            'GetNextNumber', 
            'GetNextNumberEAN', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CsSkuService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
